"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports["default"] = void 0;
exports.deleteInvoicingEntity = deleteInvoicingEntity;
exports.get = get;
exports.getInvoicingEntityByName = getInvoicingEntityByName;
exports.getInvoicingRegion = getInvoicingRegion;
exports.search = search;
exports.typeahead = typeahead;
exports.update = update;

var _api = _interopRequireWildcard(require("./api"));

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var base = '/api/invoicing-entity';

function create(invoicingEntityFormData) {
  var invoicingEntityData = invoicingEntityFormData;
  return _api["default"].post(base, invoicingEntityData).then(_api.extractData)["catch"](_api.errorHandler);
} // Update invoice entity


function update(oldInvoicingEntityData, invoicingEntityFormData) {
  var invoicingEntityData = invoicingEntityFormData;
  return _api["default"].put(base + '/' + oldInvoicingEntityData.id, invoicingEntityData).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteInvoicingEntity(invoicingEntityId) {
  return _api["default"]["delete"](base + '/' + invoicingEntityId).then(_api.extractData)["catch"](_api.errorHandler);
}

function search(query) {
  return _api["default"].post(base + '/search', query).then(_api.extractData)["catch"](_api.errorHandler);
}

function typeahead(q, parentAccountId) {
  var queryParams = _queryString["default"].stringify({
    q: q,
    parentAccountId: parentAccountId
  });

  return _api["default"].get(base + '/typeahead?' + queryParams).then(_api.extractData)["catch"](_api.errorHandler);
}

function get(invoicingEntityId) {
  return _api["default"].get("".concat(base, "/").concat(invoicingEntityId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getInvoicingRegion(invoicingRegionId) {
  return _api["default"].get('/api/invoicing-region/' + invoicingRegionId).then(_api.extractData)["catch"](_api.errorHandler);
}

function getInvoicingEntityByName(invoicingEntityName) {
  return _api["default"].get("".concat(base, "/name/").concat(invoicingEntityName)).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  create: create,
  update: update,
  deleteInvoicingEntity: deleteInvoicingEntity,
  search: search,
  typeahead: typeahead,
  get: get,
  getInvoicingRegion: getInvoicingRegion,
  getInvoicingEntityByName: getInvoicingEntityByName
};
var _default = api;
exports["default"] = _default;